const initState = () => {
  return {}
}

const dashboard = (state=initState(), action) => {
  switch (action.type) {
    case "INIT_DASHBOARD":
      return {...action.payload};

    default:
      return state;
  }
}

export default dashboard;
